import React from 'react';
import { Star, ExternalLink } from 'lucide-react';

// Google Icon als inline SVG (vereinfacht)
const GoogleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      fill="#4285F4"
    />
    <path
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      fill="#34A853"
    />
    <path
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      fill="#EA4335"
    />
  </svg>
);

const GoogleRating = ({ compact = false }) => {
  const [rating, setRating] = React.useState(5.0);
  const [reviewCount, setReviewCount] = React.useState(1);

  React.useEffect(() => {
    const loadRatingData = async () => {
      try {
        const response = await import('../data/google-reviews.json');
        const data = response.default;
        setRating(data.rating || 5.0);
        setReviewCount(data.user_ratings_total || 1);
      } catch (error) {
        // Fallback Werte bleiben
      }
    };

    loadRatingData();
  }, []);

  const handleClick = () => {
    window.open('https://g.page/r/fliesen-jarek-cuxhaven/review', '_blank');
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        className={`${compact ? 'w-3 h-3' : 'w-4 h-4'} ${
          i < rating ? 'text-yellow-400 fill-current' : 'text-stone-300'
        }`}
      />
    ));
  };

  if (compact) {
    return (
      <button
        onClick={handleClick}
        className="inline-flex items-center space-x-2 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-sm hover:bg-white transition-all duration-200 group"
      >
        <GoogleIcon className="w-4 h-4" />
        <div className="flex items-center space-x-1">
          <div className="flex">
            {renderStars(rating)}
          </div>
          <span className="text-sm font-semibold text-stone-800">
            {rating.toFixed(1)}
          </span>
        </div>
        <span className="text-xs text-stone-600">
          ({reviewCount})
        </span>
        <ExternalLink className="w-3 h-3 text-stone-400 group-hover:text-stone-600 transition-colors" />
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center space-x-3 bg-white/95 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-white/20 group"
    >
      <GoogleIcon className="w-6 h-6" />
      <div className="text-left">
        <div className="flex items-center space-x-2">
          <div className="flex">
            {renderStars(rating)}
          </div>
          <span className="text-lg font-bold text-stone-800">
            {rating.toFixed(1)}
          </span>
        </div>
        <div className="text-sm text-stone-600">
          {reviewCount} Google Bewertungen
        </div>
      </div>
      <ExternalLink className="w-4 h-4 text-stone-400 group-hover:text-primary-600 transition-colors" />
    </button>
  );
};

export default GoogleRating; 